import * as React from "react";
import styled from "@mui/material/styles/styled";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/lab";
// import DateFnsUtils from "@date-io/date-fns";
// import { PatientColorMap } from "../../../layout/patientColorMap";
// import { useTranslate } from "../../../hooks/useTranslate";
//region [[ Styles ]]
const DateQuestionPickerView = styled("div")(({ theme }) => ({}));
//endregion [[ Styles ]]
//region [[ Props ]]
export interface DateQuestionPickerProps {
  value: Date;
  onChange: (dateVal: Date) => void;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const DateQuestionPicker = ({ ...props }: DateQuestionPickerProps) => {
  //const { translate } = useTranslate();
  return (
    <DateQuestionPickerView>
      ERROR
      {/*<LocalizationProvider utils={DateFnsUtils}>*/}
      {/*  <DatePicker*/}
      {/*    inputVariant="outlined"*/}
      {/*    value={props.value}*/}
      {/*    onChange={props.onChange}*/}
      {/*    fullWidth*/}
      {/*    InputProps={{*/}
      {/*      style: {*/}
      {/*        padding: "12px",*/}
      {/*        height: 43,*/}
      {/*        background: PatientColorMap.White,*/}
      {/*      },*/}
      {/*    }}*/}
      {/*    inputProps={{*/}
      {/*      placeholder: translate("DATE_PICKER_PLACEHOLDER"),*/}
      {/*      style: {*/}
      {/*        padding: 0,*/}
      {/*      },*/}
      {/*    }}*/}
      {/*    format="MM/dd/yyyy"*/}
      {/*  />*/}
      {/*</LocalizationProvider>*/}
    </DateQuestionPickerView>
  );
};
